import { useEffect, useId, useRef } from "react";
import { X } from "lucide-react";
import { ApprovalRecipientCard, type RecipientDetails } from "./ApprovalRecipientCard";

export function ContactDetailsDialog({ details, individual, onClose }: { details: RecipientDetails; individual: boolean; onClose: () => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    const element = dialog.current!;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    element.showModal();
    return () => { element.close(); document.body.style.overflow = overflow; };
  }, []);
  return <dialog ref={dialog} className="contact-details-dialog" aria-labelledby={titleId} onCancel={onClose}>
    <header><h2 id={titleId}>Ficha del contacto</h2><button type="button" className="secondary" autoFocus aria-label="Cerrar ficha del contacto" onClick={onClose}><X size={18} />Cerrar</button></header>
    <ApprovalRecipientCard expanded contact={{ firstName: details.firstName ?? "", lastName: details.lastName ?? "", email: details.email, role: details.role ?? "", company: { name: details.company?.name ?? "", country: details.country ?? "" } }} details={details} individual={individual} />
  </dialog>;
}
